import React from 'react';

import { styled } from '@mui/material/styles';

import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

// Hooks
import { Breadcrumbs as MuiBreadcrumbs, Link } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const Root = styled('div')(() => ({
    padding: 16,
    paddingLeft: 8,
    '& .MuiTypography-root': {
        fontSize: '14px',
        color: 'white'
    }
}));

function Breadcrumbs (props) {
    const theme = useTheme();
    const navigate = useNavigate();

    const renderBreadcrumbs = () => {
        if (props.breadcrumbs) {
            return props.breadcrumbs.map(crumb => {
                if (crumb.link) {
                    return (
                        <Link key={`crumb-${crumb.title}`} href="#" onClick={() => navigate(crumb.link)}>
                            <Typography style={theme.typography.breadcrumb} color="inherit">{ crumb.title }</Typography>
                        </Link>
                    );
                } else {
                    return <Typography key={`crumb-${crumb.title}`} style={theme.typography.breadcrumbLeaf}>{ crumb.title }</Typography>;
                }
            });
        }
    };

    return (
        <Root>
            <MuiBreadcrumbs style={{ lineHeight: 1 }}>
                <Link key={'crumb-home'} href="#" onClick={() => navigate('/')}>
                    <Typography style={theme.typography.breadcrumb}>Home</Typography>
                </Link>
                { renderBreadcrumbs() }
            </MuiBreadcrumbs>
        </Root>
    );
}

export default Breadcrumbs;
